import React from 'react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { useAppSelector } from 'ducks/hooks';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const BatchDefinitions = () => {
  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <>
      <div className={cn.items}>
        <MegaMenu labels={project_name} values={projects} page="batch_definitions" />
        <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
        <div className={cn.breadcrumb}> Batch Definitions</div>
        <div className={cn.flexGrow} />
      </div>
    </>
  );
};
